<template>
    <div class="mg-bottom-15" :class="icon" v-if="value">
        <a :href="url" rel="external">
                                        <span class="fa-layers fa-fw mg-right-10">
                                            <i class="fas fa-circle fa-lg"></i>
                                            <i class="fa-inverse fab"
                                               :class="icon"
                                               data-fa-transform="right-4"></i>
                                        </span>
            <span v-text="displayText"></span>
        </a>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'SocialMediaLink',
        props: {
            platform: {type: String, required: true},
            value: {type: String, required: true}
        },
        data() {
            return {
                platforms: {
                    twitter: {
                        url: 'https://twitter.com/',
                        class: 'social-tw',
                        icon: 'fa-twitter',
                        prefix: '@',
                    },
                    facebook: {
                        url: 'https://facebook.com/',
                        class: 'social-fb',
                        icon: 'fa-facebook-f',
                        prefix: 'facebook.com/',
                    },
                    instagram: {
                        url: 'http://instagram.com/',
                        class: 'social-in',
                        icon: 'fa-instagram',
                        prefix: 'instagram.com/',
                    },
                }
            }
        },
        computed: {
            class() {
                return this.platforms[this.platform].class;
            },
            url() {
                return this.platforms[this.platform].url + this.value;
            },
            icon() {
                return this.platforms[this.platform].icon;
            },
            displayText() {
                return this.platforms[this.platform].prefix + this.value;
            }

        }
    }
</script>
